import React from 'react';
import { Button, Paper } from 'library';

import './ResourcesCTA.scss';

const ResourcesCTA = () => {
  return (
    <Paper theme="dark" pad={3.5}>
      <h2 className="ResourcesCTAHeader">Like what you&rsquo;re reading?</h2>
      <p className="ResourcesCTAText">Check out our Homeowner Resources for more info.</p>
      <Button theme="inverse" href="/homeowner-resources/" className="cta-segment-track">
        View Resources
      </Button>
    </Paper>
  );
};

export default ResourcesCTA;
